module.exports = __webpack_public_path__ + "vfn-assets/img/coin-400.5b231f78.svg";